import React, { PureComponent } from "react";
import Http from "../../networkReq/http";
import Request from "../../networkReq/request";
import { showhtml } from "utils/methods";
// require("./index.css");
import "./promiseBook.scss";
export default class Index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {}
    };
  }

  componentDidMount = () => {
    const {
      location: { state },
    } = this.props;
    console.log(state.detail);
    this.setState({
      dataInfo: state.detail || {}
    })
    console.log("searchsearch", this.props.location);
    // this.getDetail(state);
  };

  render() {
    const { dataInfo } = this.state;

    return (
      <div>
        <div className="infoBox" style={{ paddingTop: 30 }}>
          <div className="detailBox">
            <div
              className="backBtn"
              onClick={() => {
                // this.props.history.replace("/entrance/education");
                window.history.back(-1);
              }}
            >
              返回
            </div>
            {/* <div className="topBox">
              <h2>{dataInfo?.name}</h2>
            </div> */}
            <div className="detailContent">
              <div className="item">
                <div className="name">单位名称：</div>
                <div className="con"><b style={{fontWeight:'bold'}}>{dataInfo?.name}</b></div>
              </div>
              <div className="item">
                <div className="name">联盟职务：</div>
                <div className="con">{dataInfo?.duties}</div>
              </div>
              <div className="item">
                <div className="name">主要承接培训项目：</div>
                <div className="con">{dataInfo?.project}</div>
              </div>
              <div className="item">
                <div className="name">单位简介：</div>
                <div className="con">{dataInfo?.about}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
